import brand from '@helpers/brand';
import { Typography } from '@stories/Elements/Typography/Typography.styles';
import styled, { css } from 'styled-components';

const quilljsStyles = css`
  /* These are rich text styles used by the QuillJS rich text editor.
   Add new colours to: '/sitefiles/formcontrols/vendor/quilljs/quill.custom.css' too.
   */
  .ql-color-brandred {
    color: ${brand.red.base};
  }

  .ql-color-brandwhite {
    color: ${brand.white};
  }

  .ql-color-brandblack {
    color: ${brand.black};
  }

  .ql-color-branddarkgrey {
    color: ${brand.nearlyBlack};
  }

  .ql-color-brandsteel {
    color: ${brand.grey.steel};
  }
`;

const QuillJS = styled.div<{ centreText?: boolean }>`
  text-align: ${({ centreText }) => (centreText ? 'center' : 'left')};

  ${quilljsStyles};
`;

const Standard = styled.div<{ centreText?: boolean; includeQuillJS?: boolean; hide?: boolean; inheritColor?: boolean }>`
  color: ${({ inheritColor }) => (inheritColor ? 'inherit' : brand.nearlyBlack)};
  text-align: ${({ centreText }) => (centreText ? 'center' : 'left')};
  ${({ includeQuillJS }) => (includeQuillJS ? quilljsStyles : null)};
  ${({ hide }) =>
    hide
      ? css`
          display: none;
        `
      : null}

  h1 {
    ${Typography.H1Style};
    margin-bottom: 32px;
  }

  h2 {
    ${Typography.H2Style};
    margin-bottom: 28px;
  }

  h3 {
    ${Typography.H3Style};
    margin-bottom: 22px;
  }

  h4 {
    ${Typography.H4Style};
    margin-bottom: 20px;
  }

  h5 {
    ${Typography.H5Style};
    margin-bottom: 20px;
  }

  h6 {
    ${Typography.H6Style};
    margin-bottom: 20px;
  }

  p {
    ${Typography.PStyle};
    margin-bottom: 20px;
  }

  // Overwrite
  img[width] {
    width: auto !important;
  }
  img[height] {
    height: auto !important;
  }

  ul {
    text-align: left;

    li {
      position: relative;
      padding-left: 20px;

      &:before {
        content: '';
        position: absolute;
        top: 8px;
        left: 0;
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background-color: ${brand.white};
      }
    }
  }
`;

export const WYSIWYG = {
  Standard,
  QuillJS,
};
